// extracted by mini-css-extract-plugin
export default {"container":"Number_container__SgGhn","tooltip":"Number_tooltip__yv4W-","nav":"Number_nav__n8LLh","button":"Number_button__kKPnd"};